var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import VideoList from "./VideoList";
import Emoji from "../common/Emoji";
var Videos = /** @class */ (function (_super) {
    __extends(Videos, _super);
    function Videos() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Videos.prototype.render = function () {
        var _a = this.props, videos = _a.videos, currentUser = _a.currentUser, send = _a.send, devices = _a.devices;
        var videoList;
        if (videos.length > 0) {
            videoList = (React.createElement("div", null,
                React.createElement(VideoList, { devices: devices, videos: videos, send: send, currentUser: currentUser, users: this.props.users })));
        }
        else {
            videoList = (React.createElement("h5", { className: "center-message center" },
                "Sorry, no videos yet ",
                React.createElement(Emoji, { symbol: "\uD83D\uDE22" })));
        }
        return React.createElement("div", { className: "videos content container" }, videoList);
    };
    return Videos;
}(Component));
export default Videos;



//////////////////
// WEBPACK FOOTER
// ./src/components/videos/Videos.tsx
// module id = 1244
// module chunks = 0